/**
 * Limits the backend enforces on share mail (DE-1843): POST /share/, /share/notify and /share/folder-access-notify
 * answer 400 above MAX_SHARE_RECIPIENTS recipients, and /share/ and /share/notify above MAX_SHARE_MESSAGE_LENGTH
 * characters in the personal message.
 */
export const MAX_SHARE_RECIPIENTS = 50;
export const MAX_SHARE_MESSAGE_LENGTH = 1000;
